module.exports = __webpack_public_path__ + "static/media/seller1.66a2c654.svg";